<app-v2-video-player
    [completionMeasurement]="VideoCompletionMeasurement.WhenThresholdMet"
    [srcs]="teamFileVideoSources"
    [poster]="teamFileThumbnail"
    videoId="virtual-lib-player"
    [options]="{ fluid: true }"
    (completed)="watchedVideo()">
</app-v2-video-player>
